
/**
 *
 * @fileOverview CarouselController Module File
 *
 * @author jmaki
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/MediaGrid/ImageGalleryController',['require','jquery','lib/Util','GlobalEventDispatcher'],function (require) {

        var $ = require('jquery');
        var Util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');

        /**
         * This Controller is designed to allow other objects to explicitly call publicly exposed methods of an existing carousel.
         *
         * @class CarouselController         *
         * @param {CarouselView} carouselView instance of the carousel we want to control
         * @param {String} triggerSelector the string that can be used to select the trigger controllers
         * @constructor
         */
        var CarouselController = function (options) {
            this.carousel = options.carousel;
            this.$triggers = $(options.triggerSelector);
            this.settings = undefined;
            this.$modalTrigger = $(options.domTrigger);
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();// event dispatcher that will call the event, provided by the application

            /**
             * ToDO refactor this, this a pragmatic decision to get this element testable, we will not rely on calling a click
             * on the trigger in the future to get the modal to launch, instead when the modalLauncher is refactored in a less
             * complex manner, we will pass it into this or other objects so it can be used in the same way that carouselView
             * currently is
             */
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {CarouselController}
         * @since 1.0
         */
        CarouselController.prototype.init = function () {
            this.isEnabled = false;
            if (this.carousel === undefined) {
                return this;
            }
            $msg('in Image Galllery Controller init ');
            return this.setupHandlers()
                .enable();
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {CarouselController}
         * @since 1.0
         */
        CarouselController.prototype.setupHandlers = function () {
            // Bind event handlers scope here
            this.onClickHandler = this.onClick.bind(this);

            return this;
        };

        /**
         * Enables the module
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {CarouselController}
         * @since 1.0
         */
        CarouselController.prototype.enable = function () {
            /*if (this.isEnabled) {
                return this;
            }*/
            var self = this;
            this.isEnabled = true;
            /*ToDo move this logic to the actual call*/
            this.$triggers.on('click', function (event) {
                //needed for IE Support
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }
                var target = $(this).attr('href');
                self.onClickHandler(target);
            });

            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CAROUSEL_UPDATE, self.setActiveControl.bind(this));
            self.setActiveControl();

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {CarouselController}
         * @since 1.0
         */
        CarouselController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            this.$triggers.off('click', this.onClickHandler);
            // Tear down any event handlers

            return this;
        };

        /**
         *
         */
        CarouselController.prototype.setActiveControl = function () {
            this.$triggers.removeClass('MMM--isActive');
            this.$triggers.attr({'aria-selected':'false', 'role':'tab', 'tabindex':'0'});
            var activeSlideId = ('#' + this.carousel.getCurrentSlideID()).toString();
            var $activeTrigger = this.$triggers.filter('a[href="' + activeSlideId + '"]');
            $activeTrigger.addClass('MMM--isActive');
            $activeTrigger.attr('aria-selected', 'true');
        };

        /**  ToDo fix comments
         * onClick Handler
         * Performs this action on click
         *
         * @param {MouseEvent} event Click event
         * @since 1.0
         */
        CarouselController.prototype.onClick = function (target) {
            this.carousel.goToSlide(target);

            /*if (this.$modalTrigger.length > 0) {
                this.$modalTrigger.trigger('click');
            }*/
        };

        /**
         * Destroys the module
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @returns {CarouselController}
         * @since 1.0
         */
        CarouselController.prototype.destroy = function () {
            this.disable();

            return this;
        };

        return CarouselController;
    });

}(MMMRequire));

